import { Logger } from '../helpers';

export interface ILog {
    eventHeader: any;
    eventData: any;
    retryCount: number;
}

export enum TrackingEventTypes {
    init = 'init',
    log = 'log',
}

export interface ITrackingEvent<T extends any = unknown> {
    type: TrackingEventTypes;
    data: T;
}

export interface IInitObject {
    appID: string;
    productPackageID: number;
    clickStreamURL: string;
}

export interface WorkerScope extends Window {
    mainLogger: Logger;
    logLogger: Logger;
    initLogger: Logger;
    logs: ILog[];
    initObject: IInitObject;
    timeout: any;
    ranOnce: boolean;
}
